import Hero from "../components/hero/Hero";
import img5 from "../assets/img5.jpeg"
import Footer from "../components/footer/FooterSimcor";

const Home = () => {
  return (
    <>
    <Hero
      cName="hero"
      heroImg={img5}
      title="SOMOS SIMCOR"
      text="SERVICIO INTEGRAL DE MANTENIMIENTO ELÉCTRICO DE EMPRESAS"  
      btnClass="show"
      buttonText="VER MÁS"
    />
      <Footer/>
     
    </>   
  );
}



export default Home;